var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"20px"}},[_c('a-tabs',{attrs:{"default-active-key":"1"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"列表采集"}},[_c('ListCollect')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"词条采集"}},[_c('WordCollect')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }